import request from '@/axios'
export function teacher_list (schoolId, query) {
  return request({
    url: `/operationalUser/list/${schoolId}?${query.limit}?page=${query.page}`,
    method: 'GET'
  })
}

export function create_teacher (school_id, query) {
  return request({
    url: `/operationalUser/create/${school_id}`,
    method: 'POST',
    data: query
  })
}

// operationalUser/show/{operation_user_id}
// import request from '@/axios'
export function TeacherDetails (teacher_id, platform_customer_id) {
  //
  return request({
    url: `/operationalUser/show/${teacher_id}/${platform_customer_id}`,
    method: 'GET'
  })
}
export function TeacherUpdate (payload, id, platform_customer_id) {
  //
  return request({
    url: `/operationalUser/edit/${id}/${platform_customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function studentsFetchByStaff (customer_id, operation_user_id, page = 1, payload = {}) {
  //
  return request({
    url: `/operationalUser/students/${customer_id}/${operation_user_id}?page=${page}`,
    method: 'POST',
    data: payload
  })
}
